import { render, staticRenderFns } from "./ListLocationPage.vue?vue&type=template&id=06be6b51"
import script from "./ListLocationPage.vue?vue&type=script&lang=js"
export * from "./ListLocationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports